import React from "react";
import { useTranslation } from 'react-i18next';

const RelationsPagination = ({
  currentPage,
  relationsPerPage,
  totalRelations,
  paginate,
}) => {
  const { t } = useTranslation();
  const totalPages = Math.ceil(totalRelations / relationsPerPage);
  if (totalPages <= 1) return null;

  return (
    <div className="relationships-pagination">
      <button
        className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
        onClick={() => currentPage > 1 && paginate(currentPage - 1)}
        disabled={currentPage === 1}
      >
        ◀ {t('relationsPagination.previous')}
      </button>

      <div className="pagination-numbers">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => paginate(i + 1)}
            className={`pagination-number ${currentPage === i + 1 ? "active" : ""}`}
          >
            {i + 1}
          </button>
        )).slice(
          Math.max(0, currentPage - 2),
          Math.min(totalPages, currentPage + 3)
        )}
      </div>

      <button
        className={`pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
        onClick={() => currentPage < totalPages && paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        {t('relationsPagination.next')} ▶
      </button>
    </div>
  );
};

export default RelationsPagination;